import site1 from "../assets/daily/site-1.jpg";
import site2 from "../assets/daily/site-2.jpg";
import site3 from "../assets/daily/site-3.jpg";
import site4 from "../assets/daily/site-4.jpg";
import site5 from "../assets/daily/site-5.jpg";
import site6 from "../assets/daily/site-6.jpg";
import site7 from "../assets/daily/site-7.jpg";
import site8 from "../assets/daily/site-8.jpg";
import site9 from "../assets/daily/site-9.jpg";
import site10 from "../assets/daily/site-10.jpg";
import site11 from "../assets/daily/site-11.jpg";
import site12 from "../assets/daily/site-12.jpg";
import site13 from "../assets/daily/site-13.jpg";
import site14 from "../assets/daily/site-14.jpg";
import site15 from "../assets/daily/site-15.jpg";
import site16 from "../assets/daily/site-16.jpg";
import site17 from "../assets/daily/site-17.jpg";
import site18 from "../assets/daily/site-18.jpg";
import site19 from "../assets/daily/site-19.jpg";
import site20 from "../assets/daily/site-20.jpg";
import site21 from "../assets/daily/site-21.jpg";
import site22 from "../assets/daily/site-22.jpg";
import site23 from "../assets/daily/site-23.jpg";
import { dailyPhotoFile } from "../photoPick";

/**
 * Daily 사진의 목 — 사무소 작업 사진 다섯 장(`work-thing/img1~5.jpg` 을 줄여 옮긴 것)과 사무소 포트폴리오
 * 사진 열여덟 장(lifethings.in 첫 화면).
 *
 * 목에는 올린 파일 바이트를 두지 않으므로, 사진 id 마다 스물세 장 중 하나를 골라 준다.
 * 고르는 규칙은 vite 미들웨어와 함께 쓴다 → ../photoPick.ts
 */
const URL_BY_FILE: Record<string, string> = {
  "site-1.jpg": site1,
  "site-2.jpg": site2,
  "site-3.jpg": site3,
  "site-4.jpg": site4,
  "site-5.jpg": site5,
  "site-6.jpg": site6,
  "site-7.jpg": site7,
  "site-8.jpg": site8,
  "site-9.jpg": site9,
  "site-10.jpg": site10,
  "site-11.jpg": site11,
  "site-12.jpg": site12,
  "site-13.jpg": site13,
  "site-14.jpg": site14,
  "site-15.jpg": site15,
  "site-16.jpg": site16,
  "site-17.jpg": site17,
  "site-18.jpg": site18,
  "site-19.jpg": site19,
  "site-20.jpg": site20,
  "site-21.jpg": site21,
  "site-22.jpg": site22,
  "site-23.jpg": site23,
};

export const photoFor = (imageId: string) => URL_BY_FILE[dailyPhotoFile(imageId)];
